<template>
    <div class="account-ipt mobile-ipt">
      <input class="input" :class="{'error':errMsgShow}" :placeholder="CONF.mobilePlaceholder[inputType]" v-model="mobile"  v-on:focus="mobileFocus" v-on:blur="mobileBlur"/>
      <div class="country-code">
        <div class="left-line"></div>
        <div class="txt font-size14 color-msg" @click.stop="showCountry()">{{countryList[countryCodeIndex].name}}</div>
        <div class="triangle" @click.stop="showCountry()"></div>
      </div>
      <div class="msg-box" v-show="errMsgShow&&!isMobile">
        <div class="icon"></div>
        <div class="text color-msg font-size12">{{errMsg}}</div>
      </div>
      <div class="country-list" v-show="countryListShow">
        <div class="country-item" v-for="(countryItem,index ) in countryList" @click.stop="countryCheck(index)" :class="{'active':countryCodeIndex==index}">
          <div class="name">{{countryItem.name}}</div>
          <div class="code">+{{countryItem.code}}</div>
        </div>

      </div>
    </div>
</template>
<style>
  .content .mobile-ipt {
    position: relative;
  }
  .content .mobile-ipt .country-code{
    width: 121px;
    position: absolute;
    height: 48px;
    top:0;
    left: 239px;
  }
  .content .mobile-ipt input{
    padding-right: 120px;
  }
  .content .account-ipt .country-code .left-line{
    width: 1px;
    height: 20px;
    margin-top: 14px;
    background-color: #dedede;
    float:left;
  }
  .content .account-ipt .country-code .txt{
    float:left;
    line-height: 48px;
    width: 87px;
    text-align: center;
  }
  .content .account-ipt .country-code .triangle{
    float:left;
    width: 12px;
    height: 12px;
    background-image: url(../assets/img/icon_spinner.png);
    background-repeat: no-repeat;
    margin-top: 18px;
  }
  .content .country-list{
    width: 100%;
    border: 1px solid #dedede;
    height: 240px;
    line-height: 40px;
    overflow: auto;
    position: absolute;
    background-color: #ffffff;
    z-index: 1000;
  }
  .content .country-list .country-item{
    width: 100%;
    height: 40px;
  }
  .content .country-list .country-item:hover,.content .country-list .country-item:active,.content .country-list .country-item.active{
    background-color: #fafafa;
  }
  .content .country-list .country-item .name{
    width: 222px;
    height: 100%;
    float: left;
    padding-left: 18px;
  }
  .content .country-list .country-item .code{
    width: 102px;
    height: 100%;
    padding-right: 18px;
    text-align: right;
    float: left;
  }
  .content .country-list::-webkit-scrollbar{/*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
    width:2px;
    height:2px;
  }
  .content .country-list::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分（位置4）*/
    background:#dedede;
  }
  @media screen and (max-width: 600px) {
    .content .mobile-ipt .country-code {
      width: 33%;
      left: 66%;
    }
    .content .account-ipt .country-code .txt{
      width: 72.5%;
    }
    .content .account-ipt .country-code .triangle{
      width: 12%;
    }
    .content .country-list .country-item .name{
      width: 66%;
    }
    .content .country-list .country-item .code{
      width: 33%;
    }
  }
</style>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default{
    name: 'mobileInput',
    props: ['inputType', 'errData'],
    data () {
      return {
        CONF: CONF,
        errMsgShow: false,
        errMsg: '',
        mobile: '',
        countryListShow: false,
        countryList: CONF.countryList,
        countryCodeIndex: 0,
        isMobile: false
      }
    },
    watch: {
      mobile (newValue, oldValue) {
        if (newValue.length > 0) {
          this.$emit('btnEnable', newValue, this.countryCodeIndex)
        } else {
          this.$emit('btnDisable', newValue)
        }
      },
      countryCodeIndex (newValue, oldValue) {
        this.$emit('hideImgCode', newValue)
      },
      errData (newValue) {
        this.showErrMsg(newValue.errMsg)
      }
    },
    created () {
      this.isMobile = server.isMobile()
      let that = this
      window.onclick = function () {
        that.countryListShow = false
      }
    },
    methods: {
// 显示国家列表
      showCountry () {
        this.countryListShow = true
      },
// 选择国家
      countryCheck (index) {
        this.countryCodeIndex = index
        this.countryListShow = false
        this.mobileBlur()
      },
// 隐藏图形验证码
      mobileFocus () {
        this.errMsgShow = false
        this.$emit('hideImgCode')
      },
// 验证手机或邮箱格式
      mobileBlur () {
        if (this.mobile.length === 0) {
          return
        }
        if (this.inputType === CONF.inputType.mobile) {
          if ((this.countryCodeIndex === 0 && CONF.reg.chinaPhone.test(this.mobile)) || (this.countryCodeIndex !== 0 && CONF.reg.otherPhone.test(this.mobile))) {
            this.errMsgShow = false
          } else {
            this.showErrMsg(CONF.errorMsg.format.mobile)
          }
        } else {
          if (!CONF.reg.email.test(this.mobile)) {
            if ((this.countryCodeIndex === 0 && !CONF.reg.chinaPhone.test(this.mobile)) || (this.countryCodeIndex !== 0 && !CONF.reg.otherPhone.test(this.mobile))) {
              this.showErrMsg(CONF.errorMsg.format.account)
            } else {
              this.errMsgShow = false
            }
          } else {
            this.errMsgShow = false
          }
        }
      },
      showErrMsg (msg) {
        if (this.isMobile) {
          this.$toast({toastMsg: msg})
        }
        this.errMsgShow = true
        this.errMsg = msg
      }
    }
  }
</script>



// WEBPACK FOOTER //
// mobileInput.vue?5a70b576